import React, { useState } from "react";
import { calendar } from "../../common/svg";
import SecureImage from "../../components/BucketImage/Image";
const DateTimePicker: React.FC = () => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.inputWrapper,
          borderColor: isFocused ? "#000" : "#ddd",
        }}
        onClick={() => setIsFocused(!isFocused)}
        onBlur={() => setIsFocused(false)}
      >
        <div style={styles.icon}>
           <SecureImage
                        // 
                        fileKey={calendar}
                        alt="header icon"
                        width="20px"
                      />
        </div>
        <div style={styles.text}>From Date & Time - To Date & Time</div>
        <div style={styles.dropdownIcon}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "8px 16px",
    border: "1px solid #ddd",
    borderRadius: "24px",
    cursor: "pointer",
    maxWidth: "300px",
    width: "100%",
    boxSizing: "border-box",
    transition: "border-color 0.3s ease",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px",
    color: "#000",
  },
  text: {
    flexGrow: 1,
    fontSize: "14px",
    color: "#000",
    fontWeight: "normal",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  dropdownIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#000",
  },
};

export default DateTimePicker;
